import { configOption, KahunConfigurationOptionType } from "../lib/annotations";

export class PathsOptions {

    @configOption({
        description: "allows paths go thoruhg ISA edges",
    })
    isa?: boolean = true;

    @configOption({
        description: "consider isa edges as SOURCE_CAUSE_TARGET. (Misleading name)",
    })
    isaAsAssociation?: boolean = true;

    @configOption({
        description: "Allow paths with SOURCE_CAUSE_TARGET causality edge",
    })
    sourceCauseTarget?: boolean = true;

    @configOption({
        description: "Allow paths with TARGET_CUSE_SOURCE causality edge?",
    })
    targetCauseSource?: boolean = true;

    @configOption({
        description: "Allow paths with ASSOCIATION causality edge?",
    })
    association?: boolean = true;

    @configOption({
        description: "allow paths with POPULATION node in inner nodes (not source\\target nodes).",
    })
    population?: boolean = false;


    @configOption({
        description:
            "allow V-Structure  (SOURCE_CAUSE_TARGET, followed by TARGET_CAUSE_SOURCE. e.g.,  GI -causes->diarreha-causedBy->Celiac  --WRONG",
    })
    vStructure?: boolean = false;


    @configOption({
        description:
            "allow lamdba structure (TARGET_CAUSE_SOURCE, followed by SOURCE_CAUSE_TARGET. e.g., diarreha-causedBy->Celiac-causes->abdominal Pain (might be okay but we decided to turn it off)",
    })
    lambdaStructure?: boolean = false;

    @configOption({
        description:
            "allow paths to go through two elements from the same closed set.",
    })
    includePathsGoingViaClosedSet?: boolean = false;


    @configOption({
        description:
            "allows paths that starts with demographic node to consists only 1 stat edge",
    })
    longPathsStartedInPopulation?: boolean = false;

    @configOption({
        description:
            "allow child inherents etiologies from parent, e.g.  C-isa->Parent--causedBy-->E ",
    })
    childInherentParentEtiologies?: boolean = false;

    @configOption({
        description:
            "Traverse to subtypes of a uniq finding. (this flag appears in diagnosis options as well, but has different meaning)",
    })
    traverseToSubTypeFinding?: boolean = true;

    @configOption({
        description:
            "prevent paths with  ChestPain|RadiatingTo=Shoulder --isa--> ChestPain|RadiatingTo=Arm --Causes--> ArmPain",
    })
    preventRadiationParent?: boolean = true;

    @configOption({
        description:
            "Allow paths to start with ISA edge?",
    })
    startsWithISA?: boolean = true;

    @configOption({
        description:
            "Allow paths to end with NORMAL lab test",
    })
    includePathsToNormal? : boolean = false;

    @configOption({
        description:
            "limit paths to start causality path with clique nodes only. In incremental preloader this  must be FALSE. This reduces full-preload time by half.",
    })
    cliqueNodesAsCauseOnly? : boolean = false;

    @configOption({
        description:
            "prevent isa followed by subtype with two siblings which differ by the some relation with different features.",
    })
    preventTraverseInSameQualifierRelation? : boolean = true;

    @configOption({
        description:
            "prevent isa followed by subtype with two siblings which differ by the location.",
    })
    preventTraverseInSameLocationQualifierRelation? : boolean = true;

    @configOption({
        description:
            "allow companion nodes (deprecated) to be at the end of the path only.",
    })
    companionOnlyAtEnd?: boolean = true;

    @configOption({
        description:
            "allow paths with more than one edge that start\\ends with COVID.",
    })
    longCOVID19Paths? : boolean = false;

    @configOption({
        description:
            "Apply ConnectedPathFilter in addition to PathFilter.",
    })
    applyConnectedPathFilter? : boolean = false;


}
